import { render, staticRenderFns } from "./marketingChannelListShow.vue?vue&type=template&id=f9481232&scoped=true&"
import script from "./marketingChannelListShow.vue?vue&type=script&lang=js&"
export * from "./marketingChannelListShow.vue?vue&type=script&lang=js&"
import style0 from "./marketingChannelListShow.vue?vue&type=style&index=0&id=f9481232&prod&lang=scss&scoped=true&"
import style1 from "./marketingChannelListShow.vue?vue&type=style&index=1&id=f9481232&prod&lang=scss&scoped=true&"
import style2 from "./marketingChannelListShow.vue?vue&type=style&index=2&id=f9481232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9481232",
  null
  
)

export default component.exports